import { ProjectListState } from 'src/modules/project-list/types/ProjectListState';
import { RootState } from 'src/types/RootState';

export function getProjectListState(state: RootState): ProjectListState {
  return state.projectList;
}
